

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MutationStatus } from 'react-query';
import {
  ApiButton,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  HtmlTrans,
  Typography,
} from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  boldContent: {
    fontWeight: 'bold',
  },
}));

interface DialogButtonsProps {
  onDialogClose: () => void;
  apiButtonClick: () => void;
  apiButtonStatus: MutationStatus;
}

const DialogButtons = ({ onDialogClose, apiButtonStatus, apiButtonClick }: DialogButtonsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <DialogActions id="candidate-dialog-action">
      <Box className={classes.buttonContainer}>
        <Button onClick={onDialogClose} variant="text" disabled={apiButtonStatus === 'loading'}>
          {t('specialConsideration->>Dialog.Cancel')}
        </Button>
        <ApiButton status={apiButtonStatus} type="submit" onClick={apiButtonClick}>
          {t('usefulInformation->>Listing.Delete')}
        </ApiButton>
      </Box>
    </DialogActions>
  );
};

const DialogTitleContainer = () => {
  const { t } = useTranslation();
  return (
    <DialogTitle>
      <Typography variant="h4">{`${t('usefulInformation->>Listing.DeleteResource')}?`}</Typography>
    </DialogTitle>
  );
};

interface DeleteResourceDialogProps {
  modalState: boolean;
  onDialogClose: () => void;
  deleteClick: () => void;
  resourceTitle: string;
  deleteStatus: MutationStatus;
}

const DeleteResourceDialog = ({
  modalState,
  onDialogClose,
  deleteClick,
  resourceTitle,
  deleteStatus,
}: DeleteResourceDialogProps) => (
  <Dialog open={modalState} maxWidth="sm">
    <DialogTitleContainer />
    <DialogContent>
      <DialogContentText variant="body1">
        <HtmlTrans
          i18nKey="usefulInformation->>Listing.ContentDeleteResource"
          values={{
            ResourceTitle: resourceTitle,
          }}
        />
      </DialogContentText>
    </DialogContent>
    <DialogButtons
      apiButtonStatus={deleteStatus}
      onDialogClose={onDialogClose}
      apiButtonClick={deleteClick}
    />
  </Dialog>
);

export default DeleteResourceDialog;
